import { Link, useSearchParams } from 'react-router-dom'
import DataFormNew from '../../../components/common/DataFormNew'
import SectionContainer from '../../../components/common/SectionContainer'
import useData from '../../../common/hooks/useData'
import Spinner from '../../../components/common/Spinner'
import ErrorMessage from '../../../components/common/ErrorMessage'

export default function CreateProject() {
    const [searchParams] = useSearchParams()
    const orgId = searchParams.get('organizationId')

    const { org, orgLoading, orgError } = useData(
        orgId ? `/v1/organizations/${orgId}?fields=name` : null,
        'org',
    )

    const inputs = [
        {
            key: 'title',
            label: 'Title',
            required: true,
            autoComplete: 'off',
        },
        {
            key: 'descriptionHtml',
            label: 'Description',
            type: 'html',
            id: 'form-description',
        },
        {
            key: 'phaseTitles',
            label: 'Phases',
            type: 'liveSearchAddItems',
            canAddNewItem: true,
            id: 'form-phases',
            defaultValue: [],
            items: [],
            getItemText: (item) => item,
            fields: [
                {
                    column: 1,
                    getValue: (item) => item,
                },
            ],
        },
        ...(orgId
            ? [
                  {
                      key: 'organizationId',
                      type: 'text',
                      disabled: true,
                      defaultValue: org?.name,
                  },
              ]
            : [
                  {
                      key: 'organizationId',
                      label: 'Organization',
                      type: 'liveSearch',
                      required: true,
                      url: '/v1/organizations?limit=10&page=1',
                      getResultValue: (item) => item.name,
                      getItemsFromResults: (data) => data?.results || [],
                  },
              ]),
    ]

    async function getBody(data) {
        const body = { ...data }
        if (orgId) {
            body.organizationId = orgId
        }
        return body
    }

    if (orgId && orgLoading) {
        return <Spinner />
    }

    if (orgId && orgError) {
        return (
            <SectionContainer>
                <ErrorMessage>{orgError}</ErrorMessage>
            </SectionContainer>
        )
    }

    return (
        <SectionContainer>
            <DataFormNew
                initData={{
                    title: '',
                    descriptionHtml: '',
                }}
                url="/v1/tasks/projects"
                method="POST"
                submitText="Create Project"
                getSubmitMessage={(responseData) => (
                    <>
                        Created&nbsp;
                        <Link to={`/projects/${responseData.id}`}>
                            new project
                        </Link>
                        .&nbsp;
                        <Link to={`/projects/${responseData.id}/edit`}>
                            Edit
                        </Link>
                        .
                    </>
                )}
                inputs={inputs}
                getBody={getBody}
                mainButton
                mutationRegexes={[/\/v1\/tasks\/projects/]}
                submitNavArg={
                    orgId
                        ? `/organizations/${orgId}?t_title=Projects`
                        : '/projects'
                }
            />
        </SectionContainer>
    )
}
